<!-- @format -->

<template>
  <Accordion title="Dados da Movimentação">
    <!-- <DG>
      {{ localValue }}
    </DG> -->
    <div class="grid grid-cols-4 gap-5">
      <InputNumber :modelValue="localValue.id" disabled label="Código" v-if="localValue.id" />
      <Select :items="type" v-model="localValue.type" label="Tipo" required :error="localErrors.type" disabled />
      <InputDateTime v-model="localValue.date" label="Data" required :error="localErrors.date" timeStamp disabled />
      <InputZoom
        v-model="localValue.idUserApprover"
        disabled
        clearable
        label="Responsável"
        :error="localErrors.idUserApprover"
        database="user"
        item-text="name"
        item-value="id"
        required
        placeholder="Selecione o responsável" />
    </div>
  </Accordion>
  <Accordion title="Dados da Aquisição">
    <div class="grid grid-cols-4 gap-5">
      <InputNumber :modelValue="localValue.id" disabled label="Código" v-if="localValue.id" />
      <Select :items="type" v-model="localValue.typeAquisition" label="Tipo" required :error="localErrors.typeAquisition" disabled />
      <InputZoom
        required
        v-model="localValue.idDestinationWarehouse"
        label="Local Destino"
        disabled
        database="warehouse"
        item-text="name"
        item-value="id"
        placeholder="Selecione o depósito" />
      <InputDateTime v-model="localValue.acquisitionDate" label="Data de Lançamento" required :error="localErrors.acquisitionDate" timeStamp disabled />
      <InputText disabled v-model="localValue.orderNumber" label="Número do pedido" placeholder="Número do pedido" :error="localErrors.orderNumber" />
      <InputZoom
        label="Protocolo do pedido"
        v-model="localValue.orderProtocol"
        :error="localErrors.orderProtocol"
        database="os"
        item-value="protocolo"
        item-text="address"
        placeholder="Selecione o protocolo"
        disabled />
      <Select disabled v-model="localValue.orderType" label="Tipo do pedido" placeholder="ICL/Pontual" :items="orderType" :error="localErrors.orderType" />
      <InputZoom
        v-model="localValue.idItemType"
        :error="localErrors.idItemType"
        database="itemType"
        item-value="id"
        item-text="name"
        label="Tipo de Material"
        disabled
        placeholder="Selecione o tipo de material" />
      <InputZoom
        v-model="localValue.idConstructionProjectType"
        :error="localErrors.idConstructionProjectType"
        database="constructionProjectType"
        item-value="id"
        item-text="name"
        label="Tipo de Obra"
        disabled
        placeholder="Selecione o tipo de obra" />
      <InputZoom
        v-model="localValue.idContract"
        :error="localErrors.idContract"
        database="contract"
        item-value="id"
        item-text="name"
        label="Contrato"
        disabled
        placeholder="Selecione o contrato" />
      <InputZoom
        v-model="localValue.idPriceTable"
        :error="localErrors.idPriceTable"
        database="priceTable"
        item-value="id"
        item-text="name"
        label="Tabela de Preço"
        disabled
        placeholder="Selecione a tabela de preço" />
      <InputText v-model="localValue.listCode" label="Número da Lista" placeholder="Número da Lista" :error="localErrors.listCode" disabled />
      <InputText v-if="localValue.type === 'entry'" v-model="localValue.approverName" placeholder="Recebido por" label="Recebido Por" disabled />
      <InputDateTime v-if="localValue.type === 'entry'" v-model="localValue.date" label="Data do Recebimento" placeholder="Data do Recebimento" disabled />
      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" disabled />
    </div>
  </Accordion>
  <Accordion title="Dados Fiscais">
    <div class="grid grid-cols-4 gap-5">
      <InputZoom clearable v-model="localValue.idSupplier" label="Fornecedor" database="supplier" item-text="name" item-value="id" :error="localErrors.idSupplier" disabled />

      <InputText v-model="localValue.nfeKey" label="Chave de Acesso Nota Fiscal" placeholder="Chave de acesso nota fFiscal" :error="localErrors.nfeKey" disabled />

      <InputText v-model="localValue.ntm" label="Nota Fiscal" placeholder="Número de nota fiscal" :error="localErrors.ntm || localErrors.duplicateEntry" disabled />

      <InputDate v-model="localValue.nfeDate" label="Data Emissão da Nota Fiscal" :error="localErrors.nfeDate" placeholder="Selecione a data" disabled />
    </div>
  </Accordion>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useFormat } from '@/composables/useFormat'
import moment from 'moment'

const { formatDatetimeToTimezone } = useFormat()

const route = useRoute()

const type = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
  { label: 'Entrada', value: 'entry' },
  { label: 'Requisição', value: 'request' },
  { label: 'Aquisição', value: 'Aquisição' },
]

const orderType = [
  { label: 'ICL', value: 1 },
  { label: 'Pontual', value: 2 },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const restrictMode = ref(false)

// Mounted

onMounted(() => {
  // localValue.date = moment()
  localValue.typeAquisition = 'Aquisição'

  if (route.meta.type == 'restrict') {
    restrictMode.value = true
  } else {
    restrictMode.value = false
  }
})

// Watchers

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})

watch(
  () => route.meta.type,
  (newValue) => {
    if (newValue == 'restrict') {
      restrictMode.value = true
    } else {
      restrictMode.value = false
    }
  },
  { immediate: true },
)
</script>
